
















































import Vue from "vue";
import VueTrix from "vue-trix";
import { Component, Prop } from "vue-property-decorator";
import CMS_PAGE_QUERY from "@/graphql/CmsPageQuery.gql";
import SAVE_TEXT_ELEMENT_MUTATION from "@/graphql/SaveTextElementMutation.gql";
import {
  SaveTextElementMutation,
  SaveTextElementMutationVariables
} from "@/graphql/generatedTypes/SaveTextElementMutation";
import { CmsPageQuery_cmsPage } from "@/graphql/generatedTypes/CmsPageQuery";
import { ElementConfig } from "@/cms/config";
import { loremIpsum } from "@/utils/loremIpsum";
import _ from "lodash";

enum State {
  VIEWING = "VIEWING",
  EDITING = "EDITING",
  PREVIEWING_CHANGES = "PREVIEWING_CHANGES"
}

@Component({
  apollo: {
    cmsPage: {
      query: CMS_PAGE_QUERY,
      variables() {
        return { pageId: this.config.pageId, entityId: this.entityId };
      }
    }
  },
  components: {
    VueTrix
  }
})
export default class EditableText extends Vue {
  @Prop() config!: ElementConfig;
  @Prop({ default: null }) entityId!: string | null;
  cmsPage: CmsPageQuery_cmsPage | null = null;
  state: State = State.VIEWING;
  editBuffer: string = "";

  get text(): string {
    if (this.state === State.PREVIEWING_CHANGES) {
      return this.editBuffer;
    } else {
      const elementFromDb = this.textElementFromDb();

      if (elementFromDb) {
        return elementFromDb.content || "";
      } else {
        return this.defaultText();
      }
    }
  }
  get isRequestInFlight() {
    return this.cmsPage === null;
  }
  get isEditing() {
    return this.state === State.EDITING;
  }
  get isViewing() {
    return this.state === State.VIEWING;
  }
  get isPreviewing() {
    return this.state === State.PREVIEWING_CHANGES;
  }
  textElementFromDb() {
    return this.cmsPage?.textElements?.find(elem => elem.elementId === this.config.elementId);
  }
  defaultText(): string {
    if (typeof this.config.default === "string") {
      return this.config.default;
    } else {
      return loremIpsum.slice(0, this.config.default);
    }
  }
  edit(e: Event) {
    e.preventDefault();

    this.state = State.EDITING;
    this.editBuffer = this.text;
  }
  cancelEdit(e: Event) {
    e.preventDefault();

    this.state = State.VIEWING;
    this.editBuffer = "";
  }
  isViewingCmsContentGlobally() {
    return this.$authRepository.isViewingCmsContent();
  }
  previewChanges(e: Event) {
    e.preventDefault();

    this.state = State.PREVIEWING_CHANGES;
  }
  async updateText(e: Event) {
    e.preventDefault();

    const result = await this.$apollo.mutate<SaveTextElementMutation, SaveTextElementMutationVariables>({
      mutation: SAVE_TEXT_ELEMENT_MUTATION,
      variables: {
        textElementInput: {
          pageId: this.config.pageId,
          elementId: this.config.elementId,
          entityId: this.entityId === null ? null : parseInt(this.entityId),
          content: this.editBuffer
        }
      }
    });
    if (result.data?.saveTextElement?.errors?.length) {
      await this.$alertService.addAlert({
        message: "An error has occurred.",
        type: "error"
      });
    } else {
      this.$apollo.queries.cmsPage.refetch();
      this.state = State.VIEWING;
    }
  }
}
